import React, { Component } from "react";

class DigitItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            value: this.validate(props.initialValue),
            focus: false,
        };
    }

    onKeyDown = (e) => {
        if (e.keyCode === 8 && (!this.state.value || !this.state.value.length)) {
            this.props.onBackspace();
        }
    }

    clear = () => {
        this.setState({
            value: '',
        });
    }

    update(updatedValue, isPasting = false) {
        const value = this.validate(updatedValue);
        if (this.state.value === value && !isPasting) return;

        if (value.length < 2) {
            this.setState({
                value,
            });

            setTimeout(() => {
                this.props.onChange(value, isPasting);
            }, 0);
        }
    }

    onChange = (e) => {
        this.update(e.target.value);
    }

    validate = (value) => {
        const numCode = value.charCodeAt(0);
        const isInteger =
            numCode >= '0'.charCodeAt(0) && numCode <= '9'.charCodeAt(0);
        return isInteger ? value : '';
    }

    focus = () => {
        this.input.focus();
    }

    onPaste = (e) => {
        if (!this.props.onPaste) {
          return;
        }
    
        const value = e.clipboardData.getData('text');
        this.props.onPaste(value);
    }

    render() {
        const { value } = this.state;
        const { type, disabled } = this.props;
        return (
            <input
                ref={n => (this.input = n)}
                inputMode="numeric"
                type={type}
                value={value}
                maxLength="1"
                className="box"
                autoComplete="off"
                disabled={disabled}
                onChange={this.onChange}
                onKeyDown={this.onKeyDown}
                onPaste={this.onPaste}
            />
        )
    }

}

export default DigitItem;